import React, { forwardRef, Ref } from 'react';

import Button from '../Button';
import { StandardButtonTypes } from '../ButtonTypes';
import { SharedButtonProps } from '../Props';

export type StandardButtonProps = SharedButtonProps<StandardButtonTypes>;

const StandardButton = forwardRef(
    ({ children, buttonType = 'positive', ...rest }: StandardButtonProps, ref: Ref<HTMLButtonElement>): JSX.Element => (
        <Button buttonType={buttonType} {...rest} ref={ref}>
            {children}
        </Button>
    ),
);

export default StandardButton;
